import proj4 from "proj4";

// ======================================================
// Projection Definitions
// ======================================================

proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs");

proj4.defs("EPSG:32650", "+proj=utm +zone=50 +datum=WGS84 +units=m +no_defs");

class Coordinate {
    constructor() {
        this.crs = "EPSG:32650";
        this.zone = "50N";
    }

    /**
     * Latitude/Longitude → UTM
     */
    toUTM(lat, lng) {
        const [easting, northing] = proj4("EPSG:4326", this.crs, [lng, lat]);

        return {
            zone: this.zone,

            easting,

            northing,
        };
    }

    /**
     * UTM → Latitude/Longitude
     */
    toLatLon(easting, northing) {
        const [lng, lat] = proj4(this.crs, "EPSG:4326", [easting, northing]);

        return {
            lat,

            lng,
        };
    }

    /**
     * Format number
     */
    format(value, digits = 0) {
        if (value == null || Number.isNaN(value)) {
            return "-";
        }

        return Number(value).toLocaleString("en-US", {
            minimumFractionDigits: digits,

            maximumFractionDigits: digits,
        });
    }
}

export default new Coordinate();
